interface FileResult {
  base64: string | ArrayBuffer | null;
}

export const getFileFromUrl = async (url: string): Promise<FileResult> => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve({ base64: reader.result });
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
